import {useState} from "react";
import {useMountEffect} from "./mounting-hooks";

export const useDidMount = () => {
    const [didMount, setDidMount] = useState();
    useMountEffect(() => {
        setDidMount(true);
    });
    return didMount;
};